import {texture, json} from "p3";
import { Emitter } from "pixi-particles";
import common from "../../../common";
import definitions from "../../../definitions";
import Item from "./Item";
import GameScene from "../../../scenes/GameScene";
import CoinAnimation from "../misc/CoinAnimation";

export default class ItemTreasure extends Item {
    constructor(properties) {
        super(definitions.ITEM_ID.TREASURE, texture("prop_treasure_chest_00"));

        this._properties = properties;
        this._instance = null;
        this._opened = false;
        this._coinAmount = 100;
        this.interactable = false;
    }

    init() {
        super.init();

        ////console.log('TREASURE', this._properties);

        for (let i in this._properties) {
            if (this._properties[i].name == 'instance') {
                this._instance = this._properties[i].value;
            }
        }
        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.6, new PIXI.Point(0, 0));

        this._emitFx();
    }

    update() {
        this._fx && this._fx.update(window.dt);

        super.update();
    }

    _emitFx() {
        this._fx = this._createFx();
    }

    _createFx() {
        const emitter = new Emitter(this, [texture("path_tile_sparkle_attract_fx_00"), texture("path_tile_sparkle_attract_fx_01")], json("fx_treasure_chest_attract"));
        emitter.autoUpdate = false;
        emitter.updateSpawnPos(0, -40);
        return emitter;
    }

    animateFloat() {
        super.animateFloat();
        this.stopAnimations();
        this._view.anchor.y = 1;
    }

    spawn() {
        ////console.log('Treasure spawn', common.saveData.activeSlot.treasures, this._instance, common.saveData.activeSlot.treasures.indexOf(this._instance));
        if (common.saveData.activeSlot.treasures.indexOf(this._instance) >= 0) {
            this._opened = true;
            this.setTextureAsOpened();
        }
        super.spawn();
    }

    setTextureAsOpened(){
        this._texture = texture("prop_treasure_chest_01");
        this._view.texture = this._texture;
    }

    collect() {
        if (this._opened) {
            return false;
        }
        if (common.saveData.activeSlot.treasures.indexOf(this._instance) < 0) {
            common.saveData.activeSlot.treasures.push(this._instance);
            common.saveData.saveGame();
        }
        this._opened = true;
        P3.audio.playSound("music_chest_opening_good");
        const tl = new gsap.timeline({onComplete:() => {
            this._view.scale.y = 1;
            this.setTextureAsOpened();
            this._view.addChild(new CoinAnimation(this._coinAmount, GameScene.active));
            common.saveData.activeSlot.coins += this._coinAmount;
            common.saveData.saveGame();
        }});
        GameScene.active.addTween(tl);
        tl.to(this._view.scale, 0.2, {y:0.6, ease:Sine.easeIn});
        tl.to(this._view.scale, 0.1, {y:0.7, ease:Sine.easeInOut, repeat:7, yoyo:true});
        tl.to(this._view.scale, 0.1, {y:0.9, ease:Sine.easeInOut, repeat:7, yoyo:true});

        this._fx.destroy();

        return false;
    }
}